import './Header.css';
import { useContext } from 'react';
import EntityProjectsContext from '../../../EntityProjects/context/EntityProjects.context';

const Header = ({ menus }) => {
    const { infos } = useContext(EntityProjectsContext);
    return (
        <nav className="header-dashboards-nav">
            <ul className="header-dashboards-menu">
                {menus.map((menu, index) => (
                    <li
                        key={index}
                        className="header-menu-item-sidebar-dashboards"
                    >
                        <button
                            onClick={() => menu.onclick()}
                            className={`header-menu-button-sidebar-dashboards ${menu.active ? 'active' : ''
                                }`}
                            style={menu.active ? {
                                backgroundColor: infos.primary_color,
                                color: '#fff'
                            } : {}}
                        >
                            <span>{menu.title}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Header;
